import { configureStore } from "@reduxjs/toolkit";
import authReducer from './slices/auth';
import {useSelector} from "react-redux";

export const store = configureStore({
    reducer: {
        auth: authReducer
    },
});

export const useAppSelector = useSelector;
export default store;